import datapoints from '../../../datapoints';
import getFilePickerViewTypeValue from '../../../utils/getFilePickerViewTypeValue';
import OwaUserConfiguration from 'owa-service/lib/contract/OwaUserConfiguration';
import { createLegacyActionWithDatapoint } from 'owa-analytics-actions';
import { FilePickerViewType } from 'owa-filepicker';
import { updateFilePickerViewTypeConfiguration } from '../../../services/updateFilePickerConfiguration';

export default createLegacyActionWithDatapoint(
    'setUserPreferredViewType',
    datapoints.AFPChangePreferredViewType
)(function setUserPreferredViewType(
    configuration: OwaUserConfiguration,
    viewType: FilePickerViewType
) {
    configuration.ViewStateConfiguration.AttachmentsFilePickerViewTypeForMouse = getFilePickerViewTypeValue(
        viewType
    );
    updateFilePickerViewTypeConfiguration(configuration);
});
